import { PaymentMethodSkeleton } from "../loading/SkeletonBlocks.jsx";
import { formatCardExpiry } from "../../lib/cardDisplay.js";

export default function PaymentMethodCard({
  cardBrand,
  cardLast4,
  cardExpMonth,
  cardExpYear,
  isLoading = false,
  portalBusy = false,
  onUpdatePaymentMethod,
  canManage = false,
  emptyMessage = "No payment method on file.",
}) {
  const cardExpiryLabel = formatCardExpiry(cardExpMonth, cardExpYear);
  const hasCard = Boolean(cardLast4);

  if (isLoading) {
    return <PaymentMethodSkeleton />;
  }

  if (hasCard) {
    return (
      <div className="flex flex-wrap items-center justify-between gap-4 rounded-[14px] border border-hc-surface-border bg-hc-page-shell px-4 py-3.5">
        <div className="flex items-center gap-3">
          <div className="flex size-9 items-center justify-center rounded-[10px] border border-hc-surface-border bg-hc-surface">
            <i className="icon-credit-card leading-none text-hc-text-dim" aria-hidden="true" />
          </div>
          <div>
            <p className="text-sm font-medium capitalize text-hc-text">
              {cardBrand} ending in {cardLast4}
            </p>
            {cardExpiryLabel && (
              <p className="text-xs text-hc-text-dim">Expires {cardExpiryLabel}</p>
            )}
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full border border-hc-success/35 bg-hc-success-muted px-2 py-0.5 text-xs font-medium text-hc-success">
            Default
          </span>
          {canManage && onUpdatePaymentMethod ? (
            <button
              type="button"
              disabled={portalBusy}
              onClick={onUpdatePaymentMethod}
              className="rounded-[10px] border border-hc-surface-border-strong px-4 py-2 text-sm font-medium text-hc-text-muted transition hover:bg-white/5 disabled:opacity-50"
            >
              {portalBusy ? "Opening…" : "Update payment method"}
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <p className="text-xs text-hc-text-dim">{emptyMessage}</p>
      {canManage && onUpdatePaymentMethod ? (
        <button
          type="button"
          disabled={portalBusy}
          onClick={onUpdatePaymentMethod}
          className="rounded-[10px] border border-hc-surface-border-strong px-4 py-2 text-sm font-medium text-hc-text-muted transition hover:bg-white/5 disabled:opacity-50"
        >
          {portalBusy ? "Opening…" : "Add payment method"}
        </button>
      ) : null}
    </div>
  );
}
